import { FileUploadLimitations } from '../domain';
export var createFilesApi = function (baseUrl, http) {
    var url = baseUrl + "/files";
    var filesApi = {
        uploadFile: function (dto, onUploadProgress) {
            if (dto.file) {
                var formData = new FormData();
                formData.append('file', dto.file);
                formData.append('secured', "" + (dto.secured || false));
                formData.append('shortenUrl', "" + (dto.shortenUrl || false));
                return http.post(url, formData, {}, onUploadProgress);
            }
            return http.post(url, dto.form, dto.headers, onUploadProgress);
        },
        uploadFileNew: function (dto, onUploadProgress) {
            var onProgress = function (event) {
                if (event.lengthComputable) {
                    var percent = Math.round((event.loaded / event.total) * 100);
                    if (onUploadProgress) {
                        onUploadProgress(percent);
                    }
                }
            };
            if (dto.file) {
                var formData = new FormData();
                formData.append('file', dto.file);
                formData.append('secured', "" + (dto.secured || false));
                formData.append('shortenUrl', "" + (dto.shortenUrl || false));
                return http.post(baseUrl, formData, {}, onProgress);
            }
            return http.post(baseUrl, dto.form, dto.headers, onProgress);
        },
        checkFileStatus: function (dto) {
            return http.get(baseUrl + "/" + dto.fileId + "/status");
        },
        uploadImageFromUrl: function (dto) {
            return http.post(url + "/remote", dto);
        },
        uploadLimitInBytes: FileUploadLimitations.uploadLimitInBytes,
        supportedFileTypes: FileUploadLimitations.supportedFileTypesForUpload
    };
    return filesApi;
};
//# sourceMappingURL=index.js.map